import { CSSProperties } from 'react';

interface Props {
  style?: CSSProperties;
  color?: string;
  role?: string;
  'aria-label'?: string;
}

export const ExpandCircleRight = (props: Props) => {
  return (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      style={props.style ? props.style : undefined}
      role={props.role || 'img'}
      aria-label={props['aria-label'] || 'Expand Circle Right Icon'}
    >
      <title>Expand Circle Right Icon</title>
      <path
        d="M507-480 384-357l56 57 180-180-180-180-56 57 123 123ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"
        fill={props.color ? props.color : undefined}
      />
    </svg>
  );
};
